import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  backgroundColor: 'white',
};

const eventDetailSlice = createSlice({
  name: 'eventDetail',
  initialState,
  reducers: {
    setBackgroundColor(state, action) {
      state.backgroundColor = action.payload;
    },
  },
});

export const { setBackgroundColor } = eventDetailSlice.actions;
export default eventDetailSlice.reducer;